import jobSearchApi from '../job-search';

/**
 * @async
 * @param {Object} params
 * @param {string} params.language
 * @param {boolean} params.includeTermCounts
 * @param {number} params.limit
 * @param {number} params.offset
 * @param {number | undefined} [params.zoom]
 * @param {string | undefined} [cookie]
 * @returns {Promise<JobSearchResultType>}
 */
const fetchJobSearchResults = async (params, cookie) => {
  const jobAdsPromise = jobSearchApi.get({
    ...params,
    cookie,
  });
  const jobAdsResponse = await jobAdsPromise;

  if (jobAdsResponse.status !== 'OK') {
    console.error(jobAdsResponse);
    throw Error('fetchJobAds: Got unexpected response');
  }

  const { data } = jobAdsResponse;
  return data;
};

export default fetchJobSearchResults;
